import { Component, OnInit, ViewChild, HostListener, AfterViewInit } from '@angular/core';
import { MatTabChangeEvent } from '@angular/material';
import { NgForm } from '@angular/forms';
import { MenuButton } from '../../../core/shared/tabmenu/tabmenu.model';
import { EmployeesRest } from '../employee.rest';
import { PermissionsService } from '../../../core/services/permissions/permissions.service';
import { Employee, NotificationEmployee } from '../employee.model';
import { HasPermissions, Permissions } from '../../../core/services/permissions/permissions.model';
import { Router, ActivatedRoute } from '@angular/router';
import { SpinnerService } from '../../../core/services/spinner-handler/spinner-handler.service';
import { GridParamsRestoringService } from '../../../core/services/grid-params-restoring/grid-params-restoring.service';
import { ObjectToSelect } from '../../../core/shared/objectToSelect.model';
import { CustomerSelectionComponent } from '../customer-selection/customer-selection.component';
import { GridComponent } from '../../../core/shared/grid/grid.component';
import { CustomerEmployee } from '../../customers/customers.model';
import { MessageBoxComponent } from '../../../core/shared/message-box.component';
import { EmployeeDetailsHeaderComponent } from './header/employee-details-header.component';
import { GridMainFilter, SelectionMode } from '../../../core/shared/grid/grid.model';
import { AbsencesCalendarComponent } from '../../../absences/absences-calendar/absences-calendar.component';
import { DateRange } from '../../../core/shared/calendar/calendar.model';
import { DialogService } from '../../../core/shared/dialog/dialog.service';
import { EmployeeIdSelectionComponent } from '../../../core/shared/employee-selection/employee-id-selection.component';

@Component({
  selector: 'app-employee-details',
  templateUrl: './employee-details.component.html',
  styleUrls: ['./employee-details.component.scss']
})
export class EmployeeDetailsComponent implements OnInit, HasPermissions, AfterViewInit {

  permissions: Permissions;
  setPermissions(claimType: string): void {
    this.permissions = this.permissionService.getUserPermissions(claimType);
  }

  @ViewChild('employeeForm') employeeForm: NgForm;
  @ViewChild("customersGrid") customersGrid: GridComponent;
  @ViewChild(CustomerSelectionComponent) public customerSelectionModal: CustomerSelectionComponent;
  @ViewChild("employeeselection") public employeeSelectionModal: EmployeeIdSelectionComponent;
  @ViewChild("notificationEmployeesGrid") notificationEmployeesGrid: GridComponent;
  @ViewChild(MessageBoxComponent) messageBox: MessageBoxComponent;
  @ViewChild(EmployeeDetailsHeaderComponent) employeeDetailsHeaderComponent: EmployeeDetailsHeaderComponent;

  @ViewChild(AbsencesCalendarComponent) calendar: AbsencesCalendarComponent;

  public calendarMainFilter: GridMainFilter[];

  public employee: Employee;
  private isSaving = false;
  private isNew: boolean;
  private enabled: boolean;
  private calendarDateRange: DateRange;

  private saveButton = { text: 'COMMONBUTTONS_save', class: "btn-success", icon: '', onClick: () => { this.saveEmployee(); }, enabled: false, isForSelected: false };
  private menuButtons: MenuButton[] = [
    this.saveButton,
    { text: 'COMMONBUTTONS_close', class: 'btn-danger', icon: '', onClick: () => { this.close(); }, enabled: true, isForSelected: false }
  ];

  private headers = [
    { displayName: 'Kod', propertyName: 'customerCode', propertyType: 'string' },
    { displayName: 'Nazwa', propertyName: 'customerName', propertyType: 'string' },
    { displayName: 'NIP', propertyName: 'customerTin', propertyType: 'string' },
    { displayName: 'Email', propertyName: 'customerEmail', propertyType: 'string' },
    { displayName: 'Telefon', propertyName: 'customerPhone', propertyType: 'string' }
  ];

  private notificationsHeaders = [
    { displayName: 'Email', propertyName: 'email', propertyType: 'string' },
    { displayName: 'Imię', propertyName: 'name', propertyType: 'string' },
    { displayName: 'Nazwisko', propertyName: 'surname', propertyType: 'string' }
  ];

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private employeesRest: EmployeesRest,
    private permissionService: PermissionsService,
    private spinnerService: SpinnerService,
    private gridParamsRestoringService: GridParamsRestoringService,
    public dialog: DialogService,
  ) { }

  ngOnInit() {
    this.spinnerService.show();
    this.setPermissions("Employee");
    this.route.queryParams.subscribe(params => {
      if (params.employeeId && params.employeeId !== "0") {
        this.isNew = false;
        this.spinnerService.show();
        this.employeesRest.getEmployee(parseInt(params.employeeId)).subscribe(value => {
          this.employee = value;
          this.employeeDetailsHeaderComponent.setModel(this.employee, this.isNew, this.messageBox);
          this.setEnable();
          this.spinnerService.hide();
        });
      } else {
        this.spinnerService.show();
        this.isNew = true;
        this.employee = new Employee();
        this.employee.id = 0;
        this.employee.isForeignEmployee = false;
        this.employee.customers = new Array<CustomerEmployee>();
        this.employee.notificationEmployees = new Array<NotificationEmployee>();
        this.employeeDetailsHeaderComponent.setModel(this.employee, this.isNew, this.messageBox);
        this.setEnable();
        this.spinnerService.hide();
      }
    });
  }

  ngAfterViewInit() {
    this.spinnerService.hide();
  }

  @HostListener('document:keydown.control.s', ['$event']) onKeydownHandler(event: KeyboardEvent) {
    if (this.customerSelectionModal && this.customerSelectionModal.modal.modalRoot.isShown === true) {
      return;
    }

    this.saveEmployee();
    event.preventDefault();
  }

  public tabChanged(tabChangeEvent: MatTabChangeEvent): void {
    switch (tabChangeEvent.index) {
      case 1: //list
        break;

      case 2: //calendar
        this.calendarDateRange = this.calendar.calendar.currentDateRange;
        this.updateCalendarFilter();
        this.calendar.mainFilter = this.calendarMainFilter;
        this.calendar.refreshCalendarData();
        break;
      case 3:
        break;
      default:
        break;
    }
  }

  public onCalendarDateNav(dateRange: DateRange) {
    this.calendarDateRange = dateRange;
    this.updateCalendarFilter();
    this.calendar.refreshCalendarData();
  }

  private saveEmployee() {
    if (this.isInvalid()) {
      sweetAlert("Dane są niepoprawne, nie można zapisać.");
      return;
    }
    if (this.employee.isForeignEmployee && this.employee.customers.length == 0) {
      sweetAlert("Dla pracownika zewnętrznego należy dodać przynajmniej jednego kontrahenta.");
      return;
    }
    if (this.isSaving) {
      return;
    }
    this.isSaving = true;
    const action = this.employeesRest.saveEmployee;
    action.call(this.employeesRest, this.employee, this.isNew).subscribe((employee: Employee) => {
      this.router.navigate(['../../'], { relativeTo: this.route });
      this.isSaving = false;
    }, (error) => {
      this.isSaving = false;
    });
  }

  private close() {
    if (this.isSaving) {
      return;
    }
    this.router.navigate(['../../'], { relativeTo: this.route });
  }

  private setEnable() {
    this.enabled = this.permissions.canEdit;
    this.saveButton.enabled = this.enabled;
  }

  private addCustomer() {
    const action = this.employeesRest.getCustomerRows;
    action.call(this.employeesRest).subscribe((result: ObjectToSelect[]) => {
      if (result) {
        this.customerSelectionModal.selectCustomer(result, this.employee);
      }
    });
  }

  private removeCustomer(row: CustomerEmployee) {
    let message = `Czy na pewno usunąć przypisanie pracownika do kontrahenta ${row.customerName}?`;
    sweetAlert(message, {
      buttons: {
        yes: {
          text: "Tak",
          value: "yes"
        },
        no: {
          text: "Nie",
          value: "no",
        }
      }
    })
      .then((value) => {
        switch (value) {
          case "yes":
            if (row.id > 0) {
              this.employeesRest.removeCustomerEmployee(row.id).subscribe((result: boolean) => {
                if (result) {
                  this.employee.customers.splice(this.employee.customers.indexOf(row), 1);
                  this.customersGrid.refreshData();
                }
              });
            }
            else {
              this.employee.customers.splice(this.employee.customers.indexOf(row), 1);
              this.customersGrid.refreshData();
            }
            break;
        }
      });
  }

  private onSuccessOperation(event) {
    if (event.isSuccess) {
      this.employee.customers.push(event.customer);
      this.customersGrid.refreshData();
    }
  }

  private addNotificationEmployee() {
    const action = this.employeesRest.getEmployeeRows;
    action.call(this.employeesRest).subscribe((result: ObjectToSelect[]) => {
      if (result) {
        let employeeIds = this.employee.notificationEmployees.map(x => x.notificationEmployeeId);
        console.log("EmployeeDetailsComponent -> addNotificationEmployee -> employeeIds", employeeIds)
        if (this.employee.id != 0)
          employeeIds.push(this.employee.id)
        console.log("EmployeeDetailsComponent -> addNotificationEmployee -> employeeIds", employeeIds)
        this.employeeSelectionModal.selectEmployee(result, employeeIds);
      }
    });
  }

  private removeNotificationEmployee(row: NotificationEmployee) {
    let message = `Czy na pewno usunąć przypisanie pracownika powiadamianego ${row.name}?`;
    sweetAlert(message, {
      buttons: {
        yes: {
          text: "Tak",
          value: "yes"
        },
        no: {
          text: "Nie",
          value: "no",
        }
      }
    })
      .then((value) => {
        switch (value) {
          case "yes":
            if (row.id > 0) {
              this.employeesRest.removeNotificationEmployee(row.id).subscribe((result: boolean) => {
                if (result) {
                  this.employee.notificationEmployees.splice(this.employee.notificationEmployees.indexOf(row), 1);
                  this.notificationEmployeesGrid.refreshData();
                }
              });
            }
            else {
              this.employee.notificationEmployees.splice(this.employee.notificationEmployees.indexOf(row), 1);
              this.notificationEmployeesGrid.refreshData();
            }
            break;
        }
      });
  }

  private onEmployeeSelectionSuccess(event: { isSuccess: boolean, selectedEmployeeId: any }) {
    if (event.isSuccess) {
      this.employeesRest.addNotificationEmployee(event.selectedEmployeeId, this.employee.id).subscribe((result: NotificationEmployee) => {
        if (result) {
          this.employee.notificationEmployees.push(result);
          this.notificationEmployeesGrid.refreshData();
        }
      });
    }
  }


  private updateCalendarFilter() {
    this.calendarMainFilter = new Array();
    this.calendarMainFilter.push({ internalName: 'EmployeeId', value: this.employee.id.toString() });
    if (this.calendarDateRange) {
      this.calendarMainFilter.push({ internalName: 'StartDate', value: this.calendarDateRange.start.toJSON() });
      this.calendarMainFilter.push({ internalName: 'EndDate', value: this.calendarDateRange.end.toJSON() });
    }
    this.calendar.mainFilter = this.calendarMainFilter;
  }

  public isInvalid() {
    return this.employeeDetailsHeaderComponent.isInvalid();
  }
}
